import { useState, useEffect, useContext } from 'react';
import { fromEvent } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  map,
} from 'rxjs/operators';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { Employee } from 'src/tabs/hooks/useGetAllUsers';

export const useSearchTeamMember = (
  users: Array<Employee>,
  team: Array<Employee>
) => {
  const { currentUserEmail } = useContext(TeamsFxContext);
  const [inputValue, setInputValue] = useState('');
  const [teamOptions, setTeamOptions] = useState<Array<Employee>>([]);

  useEffect(() => {
    const input = document.getElementById('autocomplete-input');
    const input$ = fromEvent(input, 'input').pipe(
      debounceTime(500),
      distinctUntilChanged(),
      map((event) => {
        const { value } = event.target as HTMLInputElement;
        if (value) {
          return value;
        }
      })
    );

    const fetchOptions = (inputValue: string): Array<Employee> => {
      if (!inputValue || users.length === 0) {
        setTeamOptions([]);
        return [];
      }

      const filteredOptions = users.filter(
        (option) =>
          option?.new_name.toLowerCase().includes(inputValue.toLowerCase()) &&
          team.every(
            (person) => person.new_employeeid !== option.new_employeeid
          ) &&
          option.cra0e_email !== currentUserEmail
      );

      if (filteredOptions.length === 0) {
        setTeamOptions([]);
      }

      return filteredOptions;
    };

    const options$ = input$.pipe(switchMap(fetchOptions));

    const subscription = options$.subscribe((fetchedOptions) => {
      setTeamOptions((prev) => {
        if (prev.includes(fetchedOptions)) return [fetchedOptions];
        return [fetchedOptions, ...prev];
      });
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [users, team]);

  return { teamOptions, setTeamOptions, inputValue, setInputValue };
};
